import axios from 'axios';

export default class firstFriendResource {


    getFirstFriend(){
        return axios.get('/api/ug-first-friend/getFirstFiend')
    }

     getServices(){
        return axios.get('/api/ug-first-friend/getServices')
    }

    sentMessage(serviceID, message){

        return axios.post('/api/ug-first-friend/sentMessage',{serviceID,message})


    } 
    getLastCommunications(param,all){
        return axios.get('/api/ug-first-friend/getLastCommunications?param='+param+'&all='+all)
    }

    setAllRead(conversationID){

        return axios.post('/api/ug-first-friend/setAllRead',{conversationID:conversationID})

    }


     getAllMessages(conversationID){

        return axios.get('/api/ug-first-friend/getAllMessages?conversationID='+conversationID)

    }


    sendChatMessage(conversationID,message){

        return axios.post('/api/ug-first-friend/sendChatMessage',{conversationID,message})
    }
   
    

}
